import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Crown, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const landingFor = (role) =>
  role === "judge" ? "/judge" : role === "national_director" ? "/director"
    : role === "admin" || role === "super_admin" ? "/admin" : "/account";

export default function Login() {
  const { login, googleLogin, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { if (user) navigate(landingFor(user.role)); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate(landingFor(res.user.role));
    else setError(res.error);
  };

  return (
    <div className="grain relative flex min-h-screen items-center justify-center px-4 py-12">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(230,0,92,0.12),transparent_60%)]" />
      <div className="relative w-full max-w-md glass-strong rounded-2xl p-8" data-testid="login-form">
        <Link to="/" className="mb-6 flex items-center justify-center gap-2"><Crown className="h-7 w-7 text-gold" /><span className="font-serif text-lg text-amber-50">Miss United States of Africa</span></Link>
        <h1 className="text-center text-3xl text-amber-50">Welcome back</h1>
        <p className="mb-6 mt-1 text-center text-sm text-amber-100/60">Sign in to vote, follow candidates and more.</p>

        <button onClick={googleLogin} data-testid="google-login" className="mb-5 flex w-full items-center justify-center gap-2 rounded-full border border-gold/30 bg-white px-4 py-3 text-sm font-medium text-obsidian hover:bg-white/90">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-4 w-4" /> Continue with Google
        </button>
        <div className="mb-5 flex items-center gap-3 text-xs text-muted-foreground"><span className="h-px flex-1 bg-gold/15" /> or <span className="h-px flex-1 bg-gold/15" /></div>

        {error && <p className="mb-4 rounded-lg bg-destructive/15 px-4 py-2.5 text-sm text-red-300" data-testid="login-error">{error}</p>}
        <form onSubmit={submit} className="space-y-4">
          <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="w-full rounded-lg border border-gold/25 bg-obsidian px-4 py-3 text-sm text-amber-50 outline-none focus:border-gold" />
          <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="w-full rounded-lg border border-gold/25 bg-obsidian px-4 py-3 text-sm text-amber-50 outline-none focus:border-gold" />
          <button disabled={loading} data-testid="login-submit" className="btn-gold flex w-full items-center justify-center gap-2">{loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign In</button>
        </form>
        <p className="mt-5 text-center text-sm text-amber-100/60">No account? <Link to="/register" className="text-gold hover:underline">Create one</Link></p>
      </div>
    </div>
  );
}
